import { SET_PAGETITLE, SET_AUTH_CURRENT_USER } from "../actions";

const navbar = (state = {}, action) => {
  switch (action.type) {
    case SET_PAGETITLE:
      return (state = {
        ...state,
        pageTitle: action.title,
      });
    case SET_AUTH_CURRENT_USER:
      return (state = {
        ...state,
        authCurrentUser: action.username,
      });
    default:
      return state;
  }
};

export default navbar;
